module.exports = __webpack_public_path__ + "img/logo.8a6a9de4.png";